/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { SvgLoaderSignal } from '@coursera/coursera-ui/svg';

const styles = {
  root: css`
    padding: var(--cds-spacing-300);
  `,
};

const CenteredLoadingSpinner = ({ className }: { className?: string }) => (
  <div
    css={styles.root}
    className={classNames(className, 'rc-CenteredLoadingSpinner', 'horizontal-box', 'align-items-absolute-center')}
  >
    <SvgLoaderSignal size={48} />
  </div>
);

export default CenteredLoadingSpinner;
